import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = unknown;

export const schemaUserResolver_GetUserNames = z.array(
    UsersTableDefinitionZod.pick({
        firstName: true,
        id: true,
        lastName: true,
    }),
);

export type SchemaUserResolver_GetUserNames = z.infer<typeof schemaUserResolver_GetUserNames>;

export type UserResolver_GetUserNames = Resolver<Arguments, SchemaUserResolver_GetUserNames>;
